import { cx } from './cx';

export function Skeleton({ className, label = 'Carregando' }: { className?: string; label?: string }) {
  return <div className={cx('tae-skeleton', className)} role="status" aria-label={label} />;
}

/** Placeholder de lista/tabela durante o carregamento. */
export function LoadingSkeleton({ rows = 5, className }: { rows?: number; className?: string }) {
  return (
    <div className={cx('space-y-3', className)} role="status" aria-live="polite" aria-label="Carregando conteúdo">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="tae-skeleton h-10 w-full" aria-hidden="true" />
      ))}
    </div>
  );
}
